export default function maskString (str, pattern) {
    let i = 0;
    const padded = pattern.replace(/#/g, () => {
       return str[i++];
    });
    return padded;
 };